module.exports = __webpack_public_path__ + "static/media/complexPic5.74735c09.png";